module.exports = __webpack_public_path__ + "static/img/DACIA.54f0ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/DACIA.png
// module id = XRSn
// module chunks = 1